import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-712fe286"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "import-waiting-screen" }
const _hoisted_2 = { class: "content is-flex is-flex-direction-column is-align-items-center mb-0 mt-2 px-6" }
const _hoisted_3 = {
  class: "video-bg mb-4",
  autoplay: "",
  loop: "",
  muted: ""
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "waiting mt-10" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "buttons" }

import { ref } from 'vue'
import { useRouter } from 'vue-router'

import Animation from '@/assets/videos/animation02.mp4'
import ImportWizard from '@/popup/components/shared/Wizard.vue'
import Button from '@/popup/components/shared/Button.vue'

type Emits = {
  (event: 'import-cancel'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportWaiting',
  emits: ["import-cancel"],
  setup(__props, { emit: __emit }) {

const router = useRouter()

const emits = __emit
const animation = ref(Animation)

const onCancel = async () => {
  emits('import-cancel')
}

const onConfirm = () => {
  router.push('/')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ImportWizard, {
      title: _ctx.$t('import_wizard.import_waiting'),
      progress: 80
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("video", _hoisted_3, [
        _createElementVNode("source", {
          src: animation.value,
          type: "video/mp4"
        }, null, 8 /* PROPS */, _hoisted_4)
      ]),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('import_waiting.info1')), 1 /* TEXT */),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('import_waiting.info2')), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(Button, {
        variant: "text",
        "is-full-width": true,
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('import_waiting.cancel')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(Button, {
        variant: "primary",
        "is-full-width": true,
        onClick: onConfirm
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('import_waiting.confirm')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}
}

})